module.exports = __webpack_public_path__ + "static/media/bg3.e26780a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/contents/editorPreview/layout/components/Layout/bg/bg3.jpg
// module id = 3310
// module chunks = 0